<template>
  <div id="app" :class="pageClass">
    <BannerDeAmbiente :ambienteAtual="ambienteAtual" />
    <Acessibilidade v-if="!exibirApenasConteudo" />
    <Menu v-if="!exibirApenasConteudo"></Menu>
    <router-view></router-view>
    <Footer v-if="!exibirApenasConteudo"></Footer>
    <AssistenteNorma />
    <!-- Fora das páginas que exibem só o conteúdo, para não cobrir o texto de quem chega por um link direto. -->
    <ModalAviso
      v-if="!exibirApenasConteudo"
      titulo="Portarias Orçamentárias vão mudar lugar!"
      chave="aviso-portarias-orcamentarias-atos-infralegais"
    >
      <p>
        No dia 08/12/2026, as <strong>Portarias Orçamentárias</strong>, deixarão a aba 
        <strong>Legislações</strong> e passarão a ser publicadas em <strong>Atos Infralegais</strong>.
      </p>
      <p>Após essa data, utilize a busca de Atos Infralegais para consultar esses documentos.</p>
    </ModalAviso>
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import VueScrollTo from "vue-scrollto";
import VueSocialSharing from "vue-social-sharing";

import router from "./router";
import Menu from "./components/Menu";
import BannerDeAmbiente from "./components/BannerDeAmbiente";
import Footer from "./components/Footer";
import Acessibilidade from "./components/Acessibilidade";
import AssistenteNorma from "./components/AssistenteNorma";
import ModalAviso from "./components/ModalAviso";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err && err.name !== "NavigationDuplicated") return err;
  });
};

Vue.use(VueRouter);
Vue.use(VueMeta);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
Vue.use(VueSocialSharing);
// <norma-widget> é um custom element registrado pelo bundle externo da Norma
Vue.config.ignoredElements = ["norma-widget"];

export default {
  name: "App",
  router,
  computed: {
    pageClass() {
      return this.$route.meta.pageClass || "";
    },
  },
  data() {
    const rotasApenasConteudo = [
      "PesquisaLegislacaoShow",
      "PesquisaAtoInfralegalShow",
      "AtosInfralegaisPorEnteFederativoShow",
      "PesquisaMensagemVetoShow",
      "ConstituicaoEstadual",
      "PesquisaLegislacaoMunicipalShow",
      "PesquisaAtoInfralegalMunicipalShow",
      "PesquisaMensagemVetoMunicipalShow",
    ];
    const ambienteAtual = process.env.VUE_APP_ENV;
    return {
      rotasApenasConteudo,
      exibirApenasConteudo: rotasApenasConteudo.includes(
        this.$router.currentRoute.name,
      ),
      ambienteAtual,
    };
  },
  components: {
    Menu,
    Footer,
    BannerDeAmbiente,
    Acessibilidade,
    AssistenteNorma,
    ModalAviso,
  },
  watch: {
    $route(to) {
      this.exibirApenasConteudo = this.rotasApenasConteudo.includes(to.name);
    },
  },
};
</script>

<style lang="scss">
/* seu estilo atual */
.v-autocomplete {
  width: 100%;
  .v-autocomplete-input-group {
    .v-autocomplete-input {
      border: none;
      width: 100%;
      height: 2rem;
      border-radius: 0.2rem;
      padding-left: 0.5rem;
      font-family: "Poppins";
      font-size: 1rem;
      letter-spacing: 0.03rem;
      color: black;
    }
  }
  .v-autocomplete-list {
    z-index: 9999;
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 200px;
    overflow-y: auto;
    border-bottom: 1px solid #115810;
    .v-autocomplete-list-item {
      cursor: pointer;
      background-color: #fff;
      padding-left: 0;
      border-bottom: 1px solid #115810;
      border-left: 1px solid #115810;
      border-right: 1px solid #115810;
      &:last-child {
        border-bottom: none;
      }
      abbr {
        opacity: 0.8;
        font-size: 0.8em;
        display: block;
        font-family: sans-serif;
      }
    }
  }
}
</style>
